import ForgottenPassword from "../../components/user/forgottenPassword";

const ForgottenPage = () => {
  return <ForgottenPassword></ForgottenPassword>;
};

export default ForgottenPage;
